import { render } from "./Main.vue?vue&type=template&id=7a72fd01&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=7a72fd01&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7a72fd01"

export default script